import React, { memo, useCallback } from 'react';
import { View } from 'react-native';
import LinearGradient from 'utils/packages/linearGradient';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import { SquareBadge } from 'design-system/Badge';
import IconCheck from 'design-system/icons/IconCheck';
import useStyles from 'hooks/useStyles';
import useColors from 'hooks/useColors';
import createStyleSheets from 'utils/createStyleSheets';
import TouchableOpacity from 'utils/packages/TouchableOpacity';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import IconTransactionCategory from 'features/transactions/icons/IconTransactionCategory';
import useIsTablet from 'hooks/useIsTablet';
import { isDesktopOrWeb, isWeb } from '../../../../constants';
const EditCategoryRow = ({ item, isDefaultCategory, selected, onPress, onLongPress, }) => {
    const isFirstItem = 'customContent' in item;
    const press = useCallback(() => {
        onPress(item, isDefaultCategory);
    }, [isDefaultCategory, item, onPress]);
    const longPress = useCallback(() => {
        onLongPress(item, isDefaultCategory);
    }, [isDefaultCategory, item, onLongPress]);
    const { width } = useAppFrameDimensions(isWeb);
    const colors = useColors();
    const styles = useStyles(styleSet);
    const isTablet = useIsTablet();
    const renderImage = useCallback(() => {
        if (isFirstItem)
            return null;
        if (isDefaultCategory || item.emoji) {
            return (<IconTransactionCategory width={rem(32)} height={rem(32)} category={item} lightBackground/>);
        }
        const title = item.displayName.substring(0, 2).toUpperCase();
        return (<View style={[styles.image]}>
        <Text Text-24 OffBlack>
          {title}
        </Text>
      </View>);
    }, [isDefaultCategory, isFirstItem, item, styles.image]);
    return (<TouchableOpacity onCard hoverOnDark onPress={press} style={[
            styles.category,
            { width: isDesktopOrWeb || isTablet ? (width - rem(32)) / 4 : rem(76) },
        ]} {...(!isWeb && {
        onLongPress: longPress,
    })}>
      <View>
        <View style={styles.categoryContent}>
          <View style={styles.imageBadgeWrapper}>
            {isFirstItem ? (<LinearGradient {...colors.gradients.ultimate} colors={[colors.cards.onDark, colors.cards.onDark]} style={styles.imageContainer}>
                {item.customContent}
              </LinearGradient>) : (<View style={styles.imageContainer}>{renderImage()}</View>)}
            {selected ? (<SquareBadge fill={colors.elements.brand} offset={0} border>
                <IconCheck color={colors.elements.white}/>
              </SquareBadge>) : null}
          </View>
          <Text Text-14 numberOfLines={1} ellipsizeMode="tail" style={styles.text}>
            {item.displayName || ' '}
          </Text>
        </View>
      </View>
    </TouchableOpacity>);
};
const styleSet = createStyleSheets((colors) => ({
    category: {
        ...(isWeb && {
            padding: rem(16),
        }),
    },
    categoryContent: {
        alignItems: 'center',
    },
    imageBadgeWrapper: {
        width: rem(56),
        marginBottom: rem(8),
    },
    imageContainer: {
        height: rem(56),
        width: rem(56),
        borderRadius: rem(28),
        backgroundColor: colors.cards.onDark,
        justifyContent: 'center',
        alignItems: 'center',
    },
    image: {
        height: rem(56),
        width: rem(56),
        borderRadius: rem(28),
        justifyContent: 'center',
        alignItems: 'center',
    },
    text: {
        maxWidth: '100%',
        textAlign: 'center',
    },
}));
export default memo(EditCategoryRow);
